import React from "react";
import styles from "./RPGGameClanBase.module.scss";

const RPGGameClanBase: React.FC = () => {
  return (
    <div className={styles.rpgGameClanBase}>
      <h2>База клана</h2>
      {/* Add your clan base content here */}
    </div>
  );
};

export default RPGGameClanBase;
